import { render } from "./SidebarDadosCartao.vue?vue&type=template&id=1bf3358c&scoped=true"
import script from "./SidebarDadosCartao.vue?vue&type=script&lang=js"
export * from "./SidebarDadosCartao.vue?vue&type=script&lang=js"

import "./SidebarDadosCartao.vue?vue&type=style&index=0&id=1bf3358c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf3358c"]])

export default __exports__